import axiosClient from './axiosClient';
import { API_URLS } from '../constants/apiUrls';

const viewBookingAPI = {
  getBookingManifest: (
    ownerId: number,
    contactStaffId: number | null | undefined,
    toDate: string,
    fromDate: string,
  ) => {
    return axiosClient.get(
      `${API_URLS.VIEW_BOOKING}?ownerId=${ownerId}&contactStaffId=${contactStaffId}&toDate=${toDate}&fromDate=${fromDate}`,
    );
  },
  getAgents: (ownerId: number, contactStaffId: number | null | undefined) => {
    return axiosClient.get(
      `${API_URLS.AGENTS}?ownerId=${ownerId}&contactStaffId=${contactStaffId}`,
    );
  },
  getTripStatus: (ownerId: number) => {
    return axiosClient.get(`${API_URLS.TRIP_STATUS}?ownerId=${ownerId}`);
  },
};

export default viewBookingAPI;
